export default "__VITE_ASSET__c26630d4__"